<template>
  <v-app id="app">
    <app-nav-bar
      :open="navOpen"
      :items="menuItems"
      @navChanged="setNav"
    />
    <app-header
      :items="menuItems"
      :darbo-laikas="darboLaikas"
      :adresas="adresas"
      :telefono-numeris="telefonoNumeris"
      @nav-toggle="setNav(!navOpen)"
    />
    <v-content class="content">
      <router-view />
    </v-content>
    <app-footer
      :adresas="adresas"
      :telefono-numeris="telefonoNumeris"
    />
    <gdpr-agreement
      :has-concent="hasConcent"
      @concent="concent"
    />
  </v-app>
</template>
<script>
import appHeader from "@/app/components/appHeader";
import appFooter from "@/app/components/appFooter";
import appNavBar from "@/app/components/appNavBar";
import gdprAgreement from "@/app/components/gdprAgreement";

export default {
  name: "App",
  components: {
    appHeader,
    appFooter,
    appNavBar,
    gdprAgreement
  },
  data: () => ({
    navOpen: false,
    hasConcent: null,
    menuItems: [],
    darboLaikas: "",
    adresas: "",
    telefonoNumeris: ""
  }),
  watch: {
    hasConcent(newValue) {
      localStorage.setItem("concent", newValue);
    }
  },
  created() {
    if (localStorage.getItem("concent") === "true") {
      this.$ga.enable();
    }
    this.getContent();
  },
  mounted() {
    this.hasConcent = localStorage.getItem("concent");
  },
  methods: {
    setNav(state) {
      this.navOpen = state;
    },
    async getContent() {
      const [{ results }, { results: settings }] = await Promise.all([
        this.$prismic.client.query(
          this.$prismic.Predicates.at("document.type", "meniu"),
          { orderings: "[my.meniu.eiles_tvarka]" }
        ),
        this.$prismic.client.query(
          this.$prismic.Predicates.at("document.type", "nustatymai")
        )
      ]);
      this.menuItems = results.map(item => ({
        id: item.id,
        name: item.data.pavadinimas[0].text,
        path: item.data.adresas
      }));
      this.darboLaikas = settings[0].data["darbo_laikas"];
      this.adresas = settings[0].data["adresas"];
      this.telefonoNumeris = settings[0].data["telefono_numeris"];
    },
    concent(result) {
      this.hasConcent = result;
      if (result) {
        this.$ga.enable();
      }
    }
  }
};
</script>
<style lang="scss">
html,
body,
#admin {
  font-family: Rubik;
  background-color: #f1f1f1;
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
#app,
.v-application {
  font-family: Rubik !important;
}
h1 {
  font-family: Rubik !important;
  font-size: 2rem;
  font-weight: 600;
}
.content {
  font-family: Rubik !important;
  padding-top: 0px !important;
}
.gdpr-text {
  color: black;
}
</style>
